import React from 'react';
import Icon from '../../../components/AppIcon';
import { practitionerService } from '../../../services/practitionerService';

const ReviewStep = ({ formData }) => {
  const publicUrl = practitionerService?.getPublicUrl(formData?.slug);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="FileCheck" size={24} className="text-blue-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-900">Révision et Confirmation</h2>
          <p className="text-sm text-gray-600">Vérifiez les informations avant création</p>
        </div>
      </div>

      {/* Practice Information */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
          <Icon name="Building2" size={18} className="text-blue-600" />
          Informations du Cabinet
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Nom du Cabinet</p>
            <p className="font-medium text-gray-900">{formData?.practiceName}</p>
          </div>
          <div>
            <p className="text-gray-600">Praticien</p>
            <p className="font-medium text-gray-900">
              {formData?.practitionerTitle} {formData?.practitionerName}
            </p>
          </div>
        </div>
      </div>

      {/* Contact Details */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
          <Icon name="Mail" size={18} className="text-blue-600" />
          Coordonnées
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Email</p>
            <p className="font-medium text-gray-900">{formData?.email}</p>
          </div>
          <div>
            <p className="text-gray-600">Téléphone</p>
            <p className="font-medium text-gray-900">{formData?.phone}</p>
          </div>
          {formData?.referralEmail && (
            <div className="md:col-span-2">
              <p className="text-gray-600">Email Référals</p>
              <p className="font-medium text-gray-900">{formData?.referralEmail}</p>
            </div>
          )}
          {formData?.address && (
            <div className="md:col-span-2">
              <p className="text-gray-600">Adresse</p>
              <p className="font-medium text-gray-900">
                {formData?.address}
                {formData?.city && `, ${formData?.city}`}
                {formData?.postalCode && ` ${formData?.postalCode}`}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Branding */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
          <Icon name="Palette" size={18} className="text-blue-600" />
          Branding
        </h3>
        <div className="space-y-4">
          <div>
            <p className="text-sm text-gray-600 mb-2">URL Publique</p>
            <code className="block bg-white px-4 py-2 rounded border border-gray-200 text-sm text-gray-900">
              {publicUrl}
            </code>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-600 mb-2">Couleur Principale</p>
              <div className="flex items-center gap-2">
                <div 
                  className="w-8 h-8 rounded border border-gray-200"
                  style={{ backgroundColor: formData?.primaryColor }}
                />
                <code className="text-sm text-gray-900">{formData?.primaryColor}</code>
              </div>
            </div>
            <div>
              <p className="text-sm text-gray-600 mb-2">Couleur Secondaire</p>
              <div className="flex items-center gap-2">
                <div 
                  className="w-8 h-8 rounded border border-gray-200"
                  style={{ backgroundColor: formData?.secondaryColor }}
                />
                <code className="text-sm text-gray-900">{formData?.secondaryColor}</code>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Account Information */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
          <Icon name="UserCog" size={18} className="text-blue-600" />
          Compte Utilisateur
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-gray-600">Nom Complet</p>
            <p className="font-medium text-gray-900">{formData?.accountFullName}</p>
          </div>
          <div>
            <p className="text-gray-600">Email de Connexion</p>
            <p className="font-medium text-gray-900">{formData?.accountEmail}</p>
          </div>
          <div className="md:col-span-2">
            <p className="text-gray-600">Mot de Passe</p>
            <p className="font-medium text-gray-900">•••••••• (configuré)</p>
          </div>
        </div>
      </div>

      {/* Confirmation Notice */}
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <Icon name="CheckCircle" size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-green-800">
            <p className="font-medium mb-1">Prêt à créer</p>
            <p>
              En cliquant sur "Créer le Praticien", le compte sera activé et un email de confirmation
              sera envoyé à <strong>{formData?.accountEmail}</strong> avec les instructions de connexion.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;